import axios from "@/utils/request";
export const unDoTotal=()=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/getUnDoTaskNum",
    })
}